import React from 'react';
import { assetClassColor } from '../../utils/format';

interface BadgeProps {
  label: string;
  color?: string;
  size?: 'xs' | 'sm' | 'md';
  dot?: boolean;
}

export function Badge({ label, color, size = 'sm', dot = false }: BadgeProps) {
  const c = color || assetClassColor(label);
  const styles: Record<string, React.CSSProperties> = {
    xs: { padding: '2px 7px', fontSize: 10, borderRadius: 5, gap: 4 },
    sm: { padding: '3px 9px', fontSize: 11, borderRadius: 6, gap: 5 },
    md: { padding: '5px 12px', fontSize: 12, borderRadius: 8, gap: 5 },
  };

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        fontWeight: 500,
        letterSpacing: '0.02em',
        backgroundColor: `${c}18`,
        color: c,
        border: `1px solid ${c}30`,
        ...styles[size],
      }}
    >
      {dot && (
        <span style={{ width: 5, height: 5, borderRadius: '50%', backgroundColor: c, flexShrink: 0 }} />
      )}
      {label}
    </span>
  );
}
